import projection from '../generated/pwj201f1.json'; import { AcceptanceManifest } from '../types';
export const pwj201f1AcceptanceManifest = projection as AcceptanceManifest;
